"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeaserProperty = exports.teaserPropertyDefinition = void 0;
exports.teaserPropertyDefinition = {
    view: {
        label: 'Teaser',
        style: 'h2',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 200,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'teaser',
};
const isTeaserProperty = (prop) => {
    return prop.name === exports.teaserPropertyDefinition.name;
};
exports.isTeaserProperty = isTeaserProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhc2VyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGVhc2VyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFFBQVE7UUFDZixLQUFLLEVBQUUsSUFBSTtLQUNaO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsR0FBRztTQUNkO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFFBQVE7Q0FDaUIsQ0FBQTtBQUkxQixNQUFNLGdCQUFnQixHQUFHLENBQUMsSUFBa0IsRUFBMEIsRUFBRTtJQUM3RSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssZ0NBQXdCLENBQUMsSUFBSSxDQUFBO0FBQ3BELENBQUMsQ0FBQTtBQUZZLFFBQUEsZ0JBQWdCLG9CQUU1QiJ9